import Head from 'next/head';
import Link from 'next/link';
import { ColorThemeBoundary } from '../ColorThemeBoundary.jsx';

export function GlobalEmbed({ children }) {
  return (
    <div className="root">
      <Head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </Head>
      <ColorThemeBoundary theme="light">{children}</ColorThemeBoundary>
      <style jsx>{`
        .root {
          margin: 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
            Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
            'Segoe UI Symbol', 'Segoe UI Symbol';
          -webkit-font-smoothing: antialiased;
        }

        .root :global(a),
        .root :global(button),
        .root :global(input),
        .root :global(select),
        .root :global(textarea),
        .root :global(label) {
          -webkit-tap-highlight-color: transparent;
        }
      `}</style>
    </div>
  );
}
